export default function Footer() {
  return (
    <footer className="bg-emerald-800 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              Serene Guest House
            </h3>
            <p className="text-emerald-100 text-sm">
              Your peaceful retreat in Islamkot, offering comfort and hospitality.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              {['Home', 'About', 'Rooms', 'Amenities'].map((item) => (
                <li key={item}>
                  <button
                    onClick={() => document.getElementById(item.toLowerCase())?.scrollIntoView({ behavior: 'smooth' })}
                    className="text-emerald-100 hover:text-white transition-colors text-sm whitespace-nowrap"
                  >
                    {item}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Info</h4>
            <ul className="space-y-2 text-emerald-100 text-sm">
              <li className="flex items-start">
                <i className="ri-map-pin-line mr-2 mt-1 w-4 h-4 flex items-center justify-center"></i>
                <span>Islamkot, Sindh, Pakistan</span>
              </li>
              <li className="flex items-center">
                <i className="ri-phone-line mr-2 w-4 h-4 flex items-center justify-center"></i>
                <span>Available on request</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Follow Us</h4>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-emerald-700 rounded-full flex items-center justify-center hover:bg-emerald-600 transition-colors">
                <i className="ri-facebook-fill w-5 h-5 flex items-center justify-center"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-emerald-700 rounded-full flex items-center justify-center hover:bg-emerald-600 transition-colors">
                <i className="ri-instagram-line w-5 h-5 flex items-center justify-center"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-emerald-700 rounded-full flex items-center justify-center hover:bg-emerald-600 transition-colors">
                <i className="ri-twitter-line w-5 h-5 flex items-center justify-center"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-emerald-700 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-emerald-100 text-sm mb-4 md:mb-0">
            &copy; 2024 Serene Guest House. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-emerald-100 hover:text-white transition-colors text-sm whitespace-nowrap"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
